import React from "react";
import "../css/about.scss";

const stories = [
  { title: "Made for thoughtful moments", text: "failblossom began with a simple belief: a gift should feel personal before it is even opened. We bring food, drink and useful keepsakes together with an eye for colour, texture and the pleasure of sharing." },
  { title: "Tea, blended with care", text: "Our tea selections balance familiar comfort with bright seasonal notes. Each one is chosen to work beautifully with the biscuits, preserves and chocolates beside it." },
  { title: "Woven by hand", text: "Our hamper baskets are made by skilled makers. Natural variations in the weave give every basket its own character while strong fittings help it travel well and be reused." },
  { title: "Time around the table", text: "Afternoon tea is less about a clock and more about making room for conversation. Our collections are designed to turn an ordinary pause into something worth remembering." },
  { title: "A lighter footprint", text: "We favour reusable baskets, boxes and bags, reduce unnecessary packing, and keep looking for materials that protect each product while placing less pressure on the planet." },
  { title: "Seasonal recipes", text: "Our kitchen follows the seasons, testing small changes in flavour and texture until every biscuit, preserve and confection earns its place in a collection." },
  { title: "Open to new voices", text: "We collaborate with independent makers and creative people whose ideas bring fresh energy to the table. Different perspectives make our collections richer." },
  { title: "Recipes to keep", text: "We document the combinations, serving ideas and small rituals that make entertaining feel easy, so favourite moments can be recreated and shared." },
  { title: "Wrapped by people", text: "Every ribbon, fold and final check is handled with care. The finishing details are quiet, tactile and unmistakably failblossom." },
];

function StoryGrid({ start, count }) {
  return (
    <div className="richContent-root-63a">
      <div className="row-contained-645 row-root-63a">
        <div className="columnGroup-root-63a pagebuilder-column-group">
          <div className="pagebuilder-column-line">
            {stories.slice(start, start + count).map((story, index) => (
              <div className="column-root-63a pagebuilder-column" style={{ width: "33.3333%", padding: "0 14px" }} key={story.title}>
                <figure className="image-root-63a">
                  <img className="image-img-b79" src={`/generated/about/story-${start + index + 3}.jpg`} alt={story.title} loading="lazy" />
                </figure>
                <h2 className="content-module-title">{story.title}</h2>
                <p className="content-module-text">{story.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function About() {
  return (
    <div className="about">
      <div className="min-h-[80vh]">
        <article className="cms-root-63a px-4 blog-post">
          <h1 className="cms-heading-f74 mb-2 mt-4 text-center text-3xl md_mb-10 md_text-4xl">Our Story</h1>

          <div className="richContent-root-63a">
            <div className="row-contained-645 row-root-63a row-contained-inner">
              <figure className="image-root-63a">
                <img className="image-img-b79" src="/generated/about/story-1.jpg" title="The story of failblossom" alt="The failblossom gifting atelier" />
              </figure>
            </div>
          </div>

          <div className="richContent-root-63a">
            <div className="row-contained-645 row-root-63a row-contained-inner">
              <div className="text-root-63a" role="presentation">
                <p style={{ textAlign: "center" }}><span style={{ fontFamily: "Georgia, serif", fontStyle: "italic", fontSize: 44 }}>Gifts that grow into memories</span></p>
                <p style={{ textAlign: "center" }}><span style={{ fontFamily: "Georgia, serif", fontSize: 20, letterSpacing: 2 }}>WELCOME TO FAILBLOSSOM</span></p>
                <p style={{ textAlign: "center" }}><span style={{ fontFamily: "Georgia, serif", fontSize: 20 }}>We are an independent lifestyle and gifting brand creating generous hampers, considered treats and beautiful ways to mark everyday occasions. Our approach is modern, warm and quietly playful—rooted in good ingredients, useful objects and the happiness of giving.</span></p>
              </div>
              <figure className="image-root-63a">
                <img className="image-img-b79" src="/generated/about/story-2.jpg" alt="failblossom makers at work" loading="lazy" />
              </figure>
            </div>
          </div>

          <StoryGrid start={0} count={3} />
          <StoryGrid start={3} count={3} />
          <StoryGrid start={6} count={3} />

          <div className="richContent-root-63a">
            <div className="row-contained-645 row-root-63a row-contained-inner">
              <figure className="image-root-63a">
                <img className="image-img-b79" src="/generated/about/story-12.jpg" alt="Finished failblossom gifts" loading="lazy" />
              </figure>
              <div className="text-root-63a"><p className="content-module-text" style={{ textAlign: "center" }}>Questions about our collections or an order? Write to level@failblossom.lifestyle.</p></div>
            </div>
          </div>
        </article>
      </div>
    </div>
  );
}

export default About;
